import { useState } from 'react'
import styles from '@/components/directory/v2/list-view/EVsListItemComponent.module.css'
import EVsListItemModelComponent from '@/components/directory/v2/list-view/EVsListItemModelComponent'
import EVsListItemVariantsManager from '@/components/directory/v2/list-view/EVsListItemVariantsManager'

const EVsListItemComponent = ({ evModel }) => {
  const { make, model, variant_count } = evModel

  const encodedMake = encodeURIComponent(make)
  const encodedModel = encodeURIComponent(model)

  const [showVariants, setShowVariants] = useState(false)
  const [loadingVariants, setLoadingVariants] = useState(false)
  const [variants, setVariants] = useState(
    Array.from({ length: variant_count }, (_, index) => ({
      id: index + 1,
      loading: true,
      data: null,
    })),
  )

  const handleModelClick = () => {
    setShowVariants(!showVariants)
    if (!showVariants) {
      fetchVariants()
    }
  }

  const fetchVariants = async () => {
    setLoadingVariants(true)
    let apiUrl = `${process.env.NEXT_PUBLIC_CLEARWATT_BASE_API}/vehicles/public_list/?&make__name=${encodedMake}&model=${encodedModel}&page_size=100`

    try {
      const response = await fetch(apiUrl)
      if (!response.ok) {
        throw new Error('Network response was not ok')
      }
      const data = await response.json()
      setVariants(
        variants.map((variant, index) => ({
          ...variant,
          loading: false,
          data: data.results[index] || null,
        })),
      )
    } catch (error) {
      console.error('There has been a problem with your fetch operation:', error)
    } finally {
      setLoadingVariants(false)
    }
  }

  return (
    <div className={styles.container}>
      <div onClick={handleModelClick}>
        <EVsListItemModelComponent model_object={evModel} showVariants={showVariants} />
      </div>
      {showVariants && (
        <>
          <div className={styles.borderRight}></div>
          <EVsListItemVariantsManager variants={variants} />
          <div className={styles.footer}></div>
        </>
      )}
    </div>
  )
}

export default EVsListItemComponent
